<script lang="ts">
	interface Props {
		value: string
		maxlength: number
	}

	let { value, maxlength }: Props = $props()

	let length = $derived(value?.length || 0)

	function warningClass(length: number, maxlength: number) {
		const ratio = length / maxlength
		return ratio > 0.95 ? 'text-yellow-500' : ''
	}
</script>

<div class="mt-1"></div>
<div class="text-xs {warningClass(length, maxlength)}">
	{length}
	/
	{maxlength}
</div>
